export const RESOURCE_CATEGORIES = [
  {
    id: 'accessibility',
    label: 'Accessibility',
    source: require('../../assets/footer/accessibility.png'),
    invertInLightMode: true,
  },
  {
    id: 'safety',
    label: 'Safety',
    source: require('../../assets/footer/safety.png'),
    iconScale: 1.18,
  },
  {
    id: 'environment',
    label: 'Environment',
    source: require('../../assets/footer/environment.png'),
  },
  {
    id: 'education',
    label: 'Education',
    source: require('../../assets/footer/toolbox.png'),
    iconScale: 0.88,
  },
];

export const getResourceCategoryById = (categoryId) =>
  RESOURCE_CATEGORIES.find((category) => category.id === categoryId) || null;

export const getResourceCategoryLabel = (categoryId) =>
  getResourceCategoryById(categoryId)?.label || (categoryId ? String(categoryId) : '');

export const getResourceCategoryIconSize = (category, baseSize) =>
  Math.round(baseSize * (category?.iconScale || 1));
